import { useField } from 'formik';

import FieldRepeaterCDefault from './FieldRepeaterCDefault';

const FieldRepeaterCFormik = (props) => {
	const { name, ...rest } = props;
	const [field, meta, helpers] = useField(name);
	const { setValue } = helpers;
	const { value } = field;

	const textError = typeof meta.error === 'string' ? meta.error : undefined;
	const touchedCheck = meta.touched || meta.initialTouched;

	return (
		<FieldRepeaterCDefault
			name={name}
			value={value}
			setValue={setValue}
			error={touchedCheck && textError}
			{...rest}
		/>
	);
};

FieldRepeaterCFormik.propTypes = {
	...FieldRepeaterCDefault.propTypes,
};

export default FieldRepeaterCFormik;
